import { Component } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from '../coaching-commitment.i18n';

// TODO change to numeric
export enum CloseGoalCommitmentOption {
    GOAL_MET = 'Goal Met',
    GOAL_MOSTLY_MET = 'Goal Mostly Met',
    GOAL_OTHER_PRIORITY = 'Other Priority',
    GOAL_NO_RELATIONSHIP = 'No relationship to Behaviour Focus',
}

const OptionTlKeyMap = {
    [CloseGoalCommitmentOption.GOAL_MET]: TranslationKeyMap._741_GOAL_MET,
    [CloseGoalCommitmentOption.GOAL_MOSTLY_MET]:
        TranslationKeyMap._9528_GOAL_MOSTLY_MET,
    [CloseGoalCommitmentOption.GOAL_OTHER_PRIORITY]:
        TranslationKeyMap._9529_OTHER_PRIORITY,
    [CloseGoalCommitmentOption.GOAL_NO_RELATIONSHIP]:
        TranslationKeyMap._9530_NO_RELATIONSHIP_TO_BEHAVIOUR_FOCUS,
};

// TODO consolidate
@Component({
    selector: '[cmpsCloseGoalModal]',
    template: ` <div class="cmps-cdk-pos-relative main-container">
        <button
            type="button"
            class="close"
            (click)="_dialogRef.close(null)"
        >
            <cmps-icon
                class="cmps-cdk-fill-white"
                svgIcon="close"
            ></cmps-icon>
        </button>
        <div class="flex-grow-1 mt-5 text-center flex-row-title">
            <div class="text-right flex-item-icon ctmlph-icon">
                <cmps-icon svgIcon="loupe"></cmps-icon>
            </div>

            <div class="text-left flex-item-legend">
                <div class="close-title">
                    {{
                        _i18n._9506_IN_ORDER_TO_CLOSE_THIS_PERFORMANCE_GOAL_YOU_MUST_SELECT_A_DISPOSITION
                            | translate
                    }}
                </div>
            </div>
        </div>
        <div class="flex-grow-1 radio-group">
            <cmps-radio-group
                class="d-flex flex-column"
                [value]="_CloseGoalCommitmentOption.GOAL_MET"
                (change)="_selectedVal = $event"
            >
                <ng-container
                    *ngFor="let i of _CloseGoalCommitmentOption | keyvalue"
                >
                    <cmps-radio
                        class="cmps-radio--white"
                        [value]="i.value"
                    >
                        {{ _i18n._7440_CLOSED | translate }} -
                        {{ _OptionTlKeyMap[i.value] | translate }}
                    </cmps-radio>
                </ng-container>
            </cmps-radio-group>
        </div>

        <div class="text-center">
            <button
                cmpsOutlineButton
                (click)="_dialogRef.close(_selectedVal)"
            >
                <span cmpsOutlineButtonLabel>{{
                    _i18n._9527_CLOSE_GOAL | translate
                }}</span>
            </button>
        </div>
    </div>`,
})
export class CloseGoalModalCommitmentComponent {
    /** @private */ _CloseGoalCommitmentOption = CloseGoalCommitmentOption;
    /** @private */ _selectedVal: CloseGoalCommitmentOption =
        CloseGoalCommitmentOption.GOAL_MET;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _OptionTlKeyMap = OptionTlKeyMap;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CloseGoalModalCommitmentComponent,
            CloseGoalCommitmentOption
        >,
    ) {}
}
